<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
import './assets/stylus/index.styl'
export default {
  name: 'App'
}
</script>

<style lang="stylus">
body
  font-size: 24px; /*px*/
.wsp-logo
  position fixed
  left 50%
  bottom 132px
  transform translateX(-50%)
  display inline-block
  width 82px
  height 48px
  background-image url('./assets/images/wsp-logo.png')
  background-size 82px 48px
  background-repeat no-repeat
.el-rate
  height 36px
.el-rate__icon
    font-size: 36px;
    vertical-align middle
    margin-right: 6px;
.mint-toast
  padding 20px !important
.mint-toast-text
  font-size: 26px; /*px*/
.no-rights
  font-size: 35px; /*px*/
  text-align center
  padding 60px 0
</style>



// WEBPACK FOOTER //
// src/App.vue